module.exports = __webpack_public_path__ + "img/Mb_Exhibition_Logo.4c95c26f.png";